import { type GovernanceFormSchema, type GovernanceMutationSchema } from '../schemas';

export function governanceFormToUpdate({
  supporting_documentation,
  registered_agent_addresses,
  ...rest
}: GovernanceFormSchema): GovernanceMutationSchema {
  return {
    ...rest,
    supporting_documentation: supporting_documentation?.map((file) => file.id) ?? [],
    registered_agent_addresses: registered_agent_addresses?.map((item) => item.id) ?? [],
  };
}
